import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './AppRouter';
import RsvpPage from './pages/RsvpPage';

function App() {
  // Set the default document title for the whole application
  useEffect(() => {
    document.title = 'Paper Plane';
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/rsvp" element={<RsvpPage />} />
          <Route path="*" element={<AppRouter />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App; 